// Domain-based routing utility
// This utility helps determine which portal the user should access based on the domain

export const getDomainType = () => {
  if (typeof window === 'undefined') return 'main';
  
  const hostname = window.location.hostname;
  
  // Check for admin domain (both production and localhost)
  if (hostname.includes('admin.avsbusiness.com') || hostname === 'admin.avsbusiness.com' || 
      hostname.includes('adminavsbusiness.com') || hostname === 'adminavsbusiness.com') {
    return 'admin';
  }
  
  // Check for apps domain (both production and localhost)
  if (hostname.includes('apps.avsbusiness.com') || hostname === 'apps.avsbusiness.com' || 
      hostname.includes('apps.avsbusiness.com') || hostname === 'apps.avsbusiness.com') {
    return 'apps';
  }
  
  // Default to main domain
  return 'main';
};

export const getDefaultRoute = () => {
  const domainType = getDomainType();
  
  switch (domainType) {
    case 'admin':
      return '/adminavsbusiness.com/login';
    case 'apps':
      return '/'; // Show portal selection for apps domain
    default:
      return '/'; // Show portal selection for main domain
  }
};

export const shouldShowPortalSelection = () => {
  const domainType = getDomainType();
  return domainType === 'main' || domainType === 'apps';
};

export const getPortalRoutes = () => {
  const domainType = getDomainType();
  
  switch (domainType) {
    case 'admin':
      return {
        login: '/adminavsbusiness.com/login',
        dashboard: '/adminavsbusiness.com',
        allowedRoutes: ['/adminavsbusiness.com/login', '/adminavsbusiness.com']
      };
    case 'apps':
      return {
        billing: {
          login: '/apps.avsbusiness.com/login',
          dashboard: '/apps.avsbusiness.com'
        },
        inventory: {
          login: '/apps.avsbusiness.com/inventory/login',
          dashboard: '/apps.avsbusiness.com/inventory'
        },
        allowedRoutes: ['/', '/apps.avsbusiness.com/login', '/apps.avsbusiness.com', '/apps.avsbusiness.com/inventory/login', '/apps.avsbusiness.com/inventory']
      };
    default:
      return {
        all: {
          admin: {
            login: '/adminavsbusiness.com/login',
            dashboard: '/adminavsbusiness.com'
          },
          billing: {
            login: '/apps.avsbusiness.com/login',
            dashboard: '/apps.avsbusiness.com'
          },
          inventory: {
            login: '/apps.avsbusiness.com/inventory/login',
            dashboard: '/apps.avsbusiness.com/inventory'
          }
        },
        allowedRoutes: ['/', '/adminavsbusiness.com/login', '/adminavsbusiness.com', '/apps.avsbusiness.com/login', '/apps.avsbusiness.com', '/apps.avsbusiness.com/inventory/login', '/apps.avsbusiness.com/inventory']
      };
  }
};